import qrcode from 'qrcode-generator'
import { html } from './h.js'

/**
 * A QR code, drawn as one SVG path.
 *
 * Deliberately black on white whatever the theme is doing. A code rendered in
 * the app's own colours looks tidier and scans worse — contrast and a quiet
 * border are the whole job, and a camera pointed at a dark-mode card in poor
 * light is exactly the case that has to work.
 *
 * One path rather than a rect per module: a link code is a version-6-ish
 * symbol, which is well over a thousand rectangles, and Preact re-renders this
 * whenever anything around it changes.
 */
export function QrCode ({ text, size = 232, quiet = 3 }) {
  if (!text) return null

  const code = qrcode(0, 'M') // 0 = pick the smallest version that fits
  code.addData(String(text))
  code.make()

  const modules = code.getModuleCount()
  const side = modules + quiet * 2

  let path = ''
  for (let row = 0; row < modules; row++) {
    for (let column = 0; column < modules; column++) {
      if (code.isDark(row, column)) {
        path += 'M' + (column + quiet) + ',' + (row + quiet) + 'h1v1h-1z'
      }
    }
  }

  return html`
    <svg class="qr" width=${size} height=${size} viewBox=${'0 0 ' + side + ' ' + side}
         shape-rendering="crispEdges" role="img" aria-label="QR">
      <rect width=${side} height=${side} fill="#ffffff" />
      <path d=${path} fill="#000000" />
    </svg>`
}
